"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '20 20 60 60';

var TLogo = function TLogo() {
  return _react["default"].createElement("path", {
    d: "M25.5,35.3h-7.1V22.4h7.1V35.3z M42.3,35.4h-13v-13h13V35.4z M72.9,35.4h-9.2V78h-16V35.4v-13h25.2V35.4z M82,35.4h-5.4v-13H82V35.4z"
  });
};

var _default = (0, _createSvgIcon["default"])(TLogo, {
  viewBox: viewBox
});

exports["default"] = _default;